export default "__VITE_ASSET__S6n3H1dR__"